import { Col, Row } from "reactstrap";

export interface ErrorMessageProps {
    validationResult: any[];
    fieldToValidate: string;
}

export default function ErrorMessageComponent({
    validationResult,
    fieldToValidate,
}: ErrorMessageProps) {
    const fieldResult = validationResult.find((a) => a.path[0] === fieldToValidate);
    return (
        <>
            {typeof fieldResult && fieldResult !== "" ? (
                <Row className="errorMessage">
                    <Col>
                        <label>
                            {typeof fieldResult != "undefined"
                                ? fieldResult.message
                                : ""}
                        </label>
                    </Col>
                </Row>
            ) : null}
        </>
    );
}
